<!-- 选商品类 -->
<template>
    <div class="chooseGoodsType">
        <el-scrollbar>
            <div class="categories-tree-main">
                <div class="el-tree-node__content allType" @click="chooseNode('')">全部分类</div>
                <el-tree
                        class="filter-tree"
                        :data="goodsCategories"
                        :props="treeProps"
                        :render-content="renderCategories"
                >
                </el-tree>
            </div>
        </el-scrollbar>
    </div>
</template>
<script>
    export default {
        name: '',
        components: {

        },
        props:['from'],
        data(){
            return {
                goodsCategories:[],
                treeProps:{ // 树插件的配置
                    children:'Children'
                },
            }
        },
        mounted(){
            this.GetGoodsCategories()
        },
        watch:{

        },
        methods:{

            // 获取商品分类
            GetGoodsCategories(){
                let url = '/ERPGood/LoadGoodCategories'
                this.axios.get(url).then((res)=>{
                    let data =res.data.data
                    this.goodsCategories = data
                })
            },
            // 渲染商品分类
            renderCategories(h,{node,data}){
                return (
                    <span class="custom-tree-node" on-click={() => this.chooseNode(data)}>
                    <span>{data.Item.Name}</span>
                    </span>
                );
            },
            // 选中商品分类
            chooseNode(data){
                this.$emit('chooseNode',data)
            },
        }
    }
</script>
<style lang="less" scoped>
    .categories-tree-main {
        width: 100%;
        padding: 5px;
    }
    .allType {
        padding-left: 10px;
    }
</style>
<style>
    .custom-tree-node {
        display: inline-block;
        width: 100%;
    }
</style>
